import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="calendar-4, date" maskId="round-filled-radius-1-stroke-1.5-IconCalendar4"><path d="M7.75 2C8.16421 2 8.5 2.33579 8.5 2.75V4H15.5V2.75C15.5 2.33579 15.8358 2 16.25 2C16.6642 2 17 2.33579 17 2.75V4H19.25C20.2165 4 21 4.7835 21 5.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V5.75C3 4.7835 3.7835 4 4.75 4H7V2.75C7 2.33579 7.33579 2 7.75 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendar4;
